import Cookies from 'js-cookie'
import axios from 'axios'
import thirdConfig from './third'
import router from '../router'

let fetch = function(options) {
  return axios.post(options.url, options.data || {}, {
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
    headers: {
      'AJAX-PF-CODE': 'share',
      ZY_TRANSID: Math.random()
        .toString(36)
        .substr(2),
      USER_TOKEN_HEAD: Cookies.get('token')
    }
  })
}

export default class ZaiartLogin {
  constructor(options = { requiredPhone: true }) {
    this.requiredPhone = options.requiredPhone
    let ua = navigator.userAgent.toLowerCase()
    // 在艺
    this.isZaiartIOS =
      /from\/zaiart/gi.test(ua) && /platform\/iphone/gi.test(ua)
    this.isZaiartAndroid =
      /from\/zaiart/gi.test(ua) && /platform\/android/gi.test(ua)
    this.isZaiart = this.isZaiartIOS || this.isZaiartAndroid
    // 微信
    this.isWechat = /micromessenger/gi.test(ua)
    this.token = Cookies.get('token')
    // 登录后的回调
    this.loginCallback = null
  }
  // 登录
  login(callback) {
    this.loginCallback = callback || null
    if (this.isZaiart) {
      // 在艺登录，每次都登录
      this.zaiartLogin()
    } else {
      if (
        !this.token &&
        this.getParams('code') &&
        this.getParams('autologin') === '1'
      ) {
        this.thirdLogin()
      } else if (this.token) {
        // 检查token
        this.checkToken()
      } else if (this.isWechat) {
        // 微信登录
        this.wechatLogin()
      } else if (this.isZaiart) {
        // 在艺登录
        this.zaiartLogin()
      } else {
        // 手机登录
        this.phoneLogin()
      }
    }
  }
  // 手机登录
  phoneLogin() {
    // location.href = `${
    //   process.env.VUE_APP_LOCATION_URL
    // }/#/login?redirect_uri=${encodeURIComponent(location.href)}`
    router.push({
      path: '/login',
      query: { redirect_uri: location.href }
    })
  }
  // 微信登录
  wechatLogin() {
    thirdConfig.mpWechat.redirect_uri += `?appid=${
      thirdConfig.mpWechat.appid
    }&autologin=1&redirect_uri=${encodeURIComponent(location.href)}`
    location.href = this.json2Url(thirdConfig.mpWechat)
  }
  // 在艺登录
  zaiartLogin() {
    /* 统一调用方法 */
    window.zaiyi_login_callback = function(loginUserData) {
      loginUserData = (loginUserData && JSON.parse(loginUserData)) || {}
      // debugger
      if (loginUserData.status === '0') {
        this.loginSuccess(loginUserData.data)
      }
    }.bind(this)
    /* Android */
    window.localAndroid &&
      window.localAndroid.innerWebLogin(
        JSON.stringify({
          param: {}
        })
      )
    /* IOS */
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.innerWebLogin &&
      window.webkit.messageHandlers.innerWebLogin.postMessage(
        JSON.stringify({
          param: {}
        })
      )
  }
  // 登录成功
  loginSuccess(data) {
    // debugger
    Cookies.set('token', data.token, {
      domain: process.env.VUE_APP_COOKIES_DOMAIN,
      expires: 365
    })
    let m = window.localStorage.getItem('nophone')
    if (m === 'no') {
      this.loginCallback && this.loginCallback(data.userInfo || data)
      window.localStorage.removeItem('nophone')
      return
    }
    if (!this.isZaiart && this.requiredPhone && !data.userInfo.phone) {
      // 绑定手机号页面
      router.push({
        path: '/bindphone',
        query: { redirect_uri: location.href }
      })
      return false
    }
    this.loginCallback && this.loginCallback(data.userInfo || data)
  }
  // 检查token
  checkToken() {
    fetch({ url: '/api_user/service/aw/mul/ow/user/get_vo_simple_self' }).then(
      response => {
        let data = response.data
        if (data.code === 1) {
          this.loginSuccess({ token: this.token, userInfo: data.data })
        } else {
          Cookies.remove('token')
          this.token = null
          this.login(this.loginCallback)
        }
      }
    )
  }
  // 第三方登录
  thirdLogin() {
    let data = {
      code: this.getParams('code'),
      loginType: 4,
      appId: thirdConfig.mpWechat.appid,
      utmSource: location.href
    }
    fetch({
      url: '/api_user/service/w/account/third_login_with_out_phone',
      data
    }).then(response => {
      this.getThirdUser(data).then(() => {
        this.loginSuccess(response.data.data)
      })
    })
  }
  // 获取用户openID
  getThirdUser(data) {
    return fetch({ url: '/api_user/service/w/account/third_user', data }).then(
      response => {
        let json = JSON.parse(response.data.data.json)
        // 设置openID
        json.openid &&
          Cookies.set('openId', json.openid, {
            domain: process.env.VUE_APP_COOKIES_DOMAIN,
            expires: 365
          })
      }
    )
  }
  json2Url(json) {
    let paramArr = []
    for (let item in json) {
      if (item === 'url') {
        continue
      }
      if (item === 'redirect_uri') {
        paramArr.push(item + '=' + encodeURIComponent(json[item]))
      } else {
        paramArr.push(item + '=' + json[item])
      }
    }
    return json.url + '?' + paramArr.join('&')
  }
  getParams(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = location.href
      .split('?')
      .pop()
      .match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    }
    return ''
  }
}
